package one.healthium.uscreen.ui.animation

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.graphicsLayer
import kotlinx.coroutines.delay

@Composable
fun Modifier.staggerSlideIn(
    index: Int,
    initialDelay: Long = POST_TRANSITION_DELAY,
): Modifier {
    val progress = remember { Animatable(0f) }
    LaunchedEffect(Unit) {
        delay(initialDelay + index * STAGGER_ITEM_DELAY)
        progress.animateTo(
            targetValue = 1f,
            animationSpec = tween(
                durationMillis = STAGGER_ITEM_DURATION,
                easing = TRANSITION_EASING,
            ),
        )
    }
    return this.graphicsLayer {
        val remaining = 1f - progress.value
        alpha = progress.value
        translationY = remaining * STAGGER_OFFSET_Y
    }
}
